module.exports = __webpack_public_path__ + "static/Tech-tablet-839ff1e6c3fa3330cd9f4b2aadae6ac5.png";